import store from '../stores/reduxStore'
import _ from 'lodash'

export function getUserPermissions(key) {
  const permissions = _.get(store.getState(), 'user.data.permissions', null)
  return _.get(permissions, key)
}



// WEBPACK FOOTER //
// ./src/utils/userPermissions.js